import React, { useRef, useState } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  Table,
  Button,
  InputGroup,
} from "react-bootstrap";
import { FaSearch, FaWhatsapp, FaFileExcel, FaPrint } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useReactToPrint } from "react-to-print";

const BanquetBookingHistory = () => {
  const tableRef = useRef();

  const data = [
    {
      id: 1,
      name: "Ramesh Kumar",
      mobile: "9876543210",
      persons: 120,
      amount: 85000,
    },
    {
      id: 2,
      name: "Suresh Verma",
      mobile: "9123456789",
      persons: 80,
      amount: 56000,
    },
  ];

  // 🔹 States
  const [search, setSearch] = useState({
    name: "",
    mobile: "",
    fromDate: "",
    toDate: "",
  });

  const [filteredData, setFilteredData] = useState(data);

  // 🔹 Excel Download
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bookings");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, "Banquet_Booking_History.xlsx");
  };

  // 🔹 Print
  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
  });

  // 🔹 WhatsApp
  const sendWhatsApp = (mobile, name) => {
    const message = `Hello ${name}, regarding your banquet booking.`;
    const url = `https://wa.me/91${mobile}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  // 🔹 Search
  const handleSearch = () => {
    let result = data;

    if (search.name) {
      result = result.filter((i) =>
        i.name.toLowerCase().includes(search.name.toLowerCase())
      );
    }

    if (search.mobile) {
      result = result.filter((i) =>
        i.mobile.includes(search.mobile)
      );
    }

    setFilteredData(result);
  };

  // 🔹 Clear Search
  const handleClear = () => {
    setSearch({
      name: "",
      mobile: "",
      fromDate: "",
      toDate: "",
    });
    setFilteredData(data);
  };

  return (
    <Container className="my-4">
      <Card className="shadow-lg">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="fw-bold mb-0">Banquet Booking History</h4>

            <div className="d-flex gap-2">
              <Button variant="success" onClick={exportToExcel}>
                <FaFileExcel className="me-1" /> Excel
              </Button>

              <Button variant="secondary" onClick={handlePrint}>
                <FaPrint className="me-1" /> Print
              </Button>
            </div>
          </div>

          {/* 🔍 Search Filters */}
          <Row className="g-3 mb-3">
            <Col md={3}>
              <InputGroup>
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Guest Name"
                  value={search.name}
                  onChange={(e) =>
                    setSearch({ ...search, name: e.target.value })
                  }
                />
              </InputGroup>
            </Col>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Mobile No"
                  value={search.mobile}
                  onChange={(e) =>
                    setSearch({ ...search, mobile: e.target.value })
                  }
                />
              </InputGroup>
            </Col>

            <Col md={3}>
              <Form.Control
                type="date"
                value={search.fromDate}
                onChange={(e) =>
                  setSearch({ ...search, fromDate: e.target.value })
                }
              />
            </Col>

            <Col md={3}>
              <Form.Control
                type="date"
                value={search.toDate}
                onChange={(e) =>
                  setSearch({ ...search, toDate: e.target.value })
                }
              />
            </Col>
          </Row>

          {/* 🔍 Buttons */}
          <Row className="mb-4">
            <Col className="text-end">
              <Button variant="primary" onClick={handleSearch}>
                <FaSearch className="me-1" /> Search
              </Button>

              <Button
                variant="outline-secondary"
                className="ms-2"
                onClick={handleClear}
              >
                Clear
              </Button>
            </Col>
          </Row>

          {/* 📋 Table */}
          <div ref={tableRef}>
            <Table bordered hover responsive>
              <thead className="table-light">
                <tr>
                  <th>Guest Name</th>
                  <th>Mobile</th>
                  <th>Total Persons</th>
                  <th>Amount (₹)</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item) => (
                    <tr key={item.id}>
                      <td>{item.name}</td>
                      <td>{item.mobile}</td>
                      <td>{item.persons}</td>
                      <td>{item.amount}</td>
                      <td className="d-flex gap-2">
                        <Button
                          size="sm"
                          variant="success"
                          onClick={() =>
                            sendWhatsApp(item.mobile, item.name)
                          }
                        >
                          <FaWhatsapp />
                        </Button>

                        <Button size="sm" variant="info">
                          View More
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default BanquetBookingHistory;
